import React from 'react'
import {Routes, Route} from 'react-router-dom'
import DashboardPage from 'components/pages/DashboardPage'
import LoginPage from 'components/pages/LoginPage'
import {NotFoundPage} from 'components/pages/NotFoundPage'
import SignUpPage from 'components/pages/SignUpPage'
import SetupPage from 'components/pages/SetupPage'
import {UsersPage, InviteUserPage, UserDetailPage} from 'components/pages/users'
import UnauthenticatedRoute from 'components/UnauthenticatedRoute'
import AuthenticatedRoute from 'components/AuthenticatedRoute'
import {AccountSettingsPage} from 'components/pages/account'
import {ProductsPage, AddProductPage, ProductDetailPage, EditProductPage} from 'components/pages/products'

const AppRoutes = () => (
  <Routes>
    <Route path="/login" element={<UnauthenticatedRoute component={LoginPage} />} />
    <Route path="/signup" element={<UnauthenticatedRoute component={SignUpPage} />} />
    <Route path="/setup" element={<AuthenticatedRoute component={SetupPage} />} />
    <Route path="/" element={<AuthenticatedRoute component={DashboardPage} />} />
    <Route path="/users" element={<AuthenticatedRoute component={UsersPage} />} />
    <Route path="/users/invite" element={<AuthenticatedRoute component={InviteUserPage} />} />
    <Route path="/users/:id" element={<AuthenticatedRoute component={UserDetailPage} />} />
    <Route path="/me/settings" element={<AuthenticatedRoute component={AccountSettingsPage} />} />
    <Route path="/products" element={<AuthenticatedRoute component={ProductsPage} />} />
    <Route path="/products/add" element={<AuthenticatedRoute component={AddProductPage} />} />
    <Route path="/products/:id/edit" element={<AuthenticatedRoute component={EditProductPage} />} />
    <Route path="/products/:id" element={<AuthenticatedRoute component={ProductDetailPage} />} />
    <Route path="*" element={<AuthenticatedRoute component={NotFoundPage} />} />
  </Routes>
)

export default AppRoutes
